module.exports = __webpack_public_path__ + "media/CheeseWire.0a681b77.mp4";